<script lang="ts">
  import * as Turbo from "@hotwired/turbo";
  import Icon from '$shared/icons/Icon.svelte';

  import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
  import { Button } from '$lib/components/ui/button';

  export let row: any;

  function handleClickView(row: any) {
    Turbo.visit(row.url);
  }
</script>

{#if row.url}
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild let:builder>
      <Button variant="ghost" builders={[builder]} size="icon" class="relative w-8 h-8 p-0">
        <span class="sr-only">Open menu</span>
        <Icon icon="MoreHorizontal" size="small" />
      </Button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content>
      <DropdownMenu.Item on:click={() => handleClickView(row)}>View on platform</DropdownMenu.Item>
    </DropdownMenu.Content>
  </DropdownMenu.Root>
{/if}
